import { InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import type { InputProps } from "../answers";

import { fieldSx } from "./optionSx";

export const NumberInput: React.FC<InputProps<"number">> = ({ question, answer, onChange, error }) => {
    const { formatMessage } = useIntl();
    const [draft, setDraft] = useState(answer?.value === undefined ? "" : String(answer.value));
    const [seen, setSeen] = useState(answer?.value);
    if (seen !== answer?.value) {
        setSeen(answer?.value);
        if (draft.trim() === "" ? answer?.value !== undefined : Number(draft) !== answer?.value)
            setDraft(answer?.value === undefined ? "" : String(answer.value));
    }
    const { min, max } = question;
    const range =
        min === 0 && max === undefined
            ? undefined
            : min !== undefined && max !== undefined
              ? formatMessage({ defaultMessage: "Between {min} and {max}" }, { min, max })
              : min !== undefined
                ? formatMessage({ defaultMessage: "At least {min}" }, { min })
                : max !== undefined
                  ? formatMessage({ defaultMessage: "At most {max}" }, { max })
                  : undefined;

    return (
        <TextField
            size="small"
            type="number"
            value={draft}
            error={error}
            helperText={range}
            placeholder={formatMessage({ defaultMessage: "Enter a number" })}
            onChange={(event) => {
                setDraft(event.target.value);
                if ((event.target as HTMLInputElement).validity.badInput) return;
                const parsed = Number(event.target.value);
                if (event.target.value.trim() === "") onChange({ ...answer, value: undefined });
                else if (Number.isFinite(parsed)) onChange({ ...answer, value: parsed });
            }}
            slotProps={{
                htmlInput: { min, max },
                input: question.unit
                    ? { endAdornment: <InputAdornment position="end">{question.unit}</InputAdornment> }
                    : undefined,
            }}
            sx={fieldSx}
        />
    );
};
